var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.name,
            expression: "rules.name"
          }
        ],
        attrs: {
          label: "Name",
          name: "Name",
          placeholder: "Valid zone name",
          "error-messages": _vm.errors.collect("Name")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.domain,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "domain", $$v)
          },
          expression: "model.domain"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.priority,
            expression: "rules.priority"
          }
        ],
        attrs: {
          label: "Priority",
          name: "Priority",
          placeholder: "Integer",
          "error-messages": _vm.errors.collect("Priority")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.priority,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "priority", $$v)
          },
          expression: "model.priority"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.ttl,
            expression: "rules.ttl"
          }
        ],
        attrs: {
          label: "TTL",
          name: "TTL",
          placeholder: "14400",
          "error-messages": _vm.errors.collect("TTL")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.ttl,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "ttl", $$v)
          },
          expression: "model.ttl"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules.destination,
            expression: "rules.destination"
          }
        ],
        attrs: {
          label: "Destination",
          name: "Destination",
          placeholder: "Fully qualified domain name",
          "error-messages": _vm.errors.collect("Destination")
        },
        on: {
          input: _vm.sendData
        },
        model: {
          value: _vm.model.exchanger,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "exchanger", $$v)
          },
          expression: "model.exchanger"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }